import { render, staticRenderFns } from "./trip-thumbnail.vue?vue&type=template&id=1a2e3890&scoped=true"
import script from "./trip-thumbnail.vue?vue&type=script&lang=js"
export * from "./trip-thumbnail.vue?vue&type=script&lang=js"
import style0 from "./trip-thumbnail.vue?vue&type=style&index=0&id=1a2e3890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2e3890",
  null
  
)

export default component.exports